import React, { Component } from 'react';
import { Divider, Button } from 'semantic-ui-react'
import { getOrderKey,  base, } from '../../../../config/constants.js'
import { ShowSingleOrderDetails } from '../DashboardParts'


export class ViewSingleOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            singleOrders: []
        }
    }


    
    componentDidMount() {
           // console.log("vlx1 ViewSingleOrders:"+this.props.user);
    }

    showOrders = () => {
       // console.log("baseX +++++++++++: showOrders");
        //console.log("baseX1 this.props.mainOrder.key:"+this.props.mainOrder.key);
      //  console.log("baseX1 this.props.mainOrder.key:"+getOrderKey(this.props.mainOrder));

        

        //base.syncState('orders/' + this.props.mainOrder.key + '/singleOrders', {
        base.syncState('orders/' + getOrderKey(this.props.mainOrder) + '/singleOrders', {
            context: this,
            asArray: true,
            state: 'singleOrders'
        });
    }

    render() {

        const orders = this.state.singleOrders.map((order, index) =>
            <div>
                {/* <Header sub>Order #1</Header> */}
                <Divider horizontal>{'ORDER ' + (index + 1)}</Divider>
                <ShowSingleOrderDetails
                    orderNumber={'order' + (index + 1)}
                    mainOrder={this.props.mainOrder}
                    order={order} 
                    user={this.props.user}/>
            </div>


        )

        return (
            <div>
                {orders}
                <Button color='teal' onClick={this.showOrders}>VIEW SHIRTS</Button>
            </div>
        )
    }
}

export default ViewSingleOrders;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ViewSingleOrders/ViewSingleOrders.js